import { IikoModifierSetTypeDto, ModifierSetTypeDto } from "services/modifierSets/restModels";

export const MODIFIER_SET_TYPE_LABELS: Record<ModifierSetTypeDto, string> = {
    [ModifierSetTypeDto.ChooseOne]: "Один из списка",
    [ModifierSetTypeDto.ChooseMany]: "Несколько из списка",
};

export const MODIFIER_SET_TYPE_DESCRIPTIONS: Record<ModifierSetTypeDto, string> = {
    [ModifierSetTypeDto.ChooseOne]: "Гость выбирает ровно один вариант — размер, тип молока",
    [ModifierSetTypeDto.ChooseMany]: "Гость набирает любое количество вариантов в заданных пределах",
};

// Пустая строка — «набор не привязан к внешнему меню».
export const NO_IIKO_SET_TYPE = "";

export const IIKO_SET_TYPE_LABELS: Record<IikoModifierSetTypeDto, string> = {
    [IikoModifierSetTypeDto.PriceSize]: "Размеры",
    [IikoModifierSetTypeDto.Modifiers]: "Простые модификаторы",
    [IikoModifierSetTypeDto.GroupModifiers]: "Групповые модификаторы",
};
